module.exports = __webpack_public_path__ + "545474e27f4b55b20a21e2e802310e63.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/dow_image_1.jpg
// module id = 136
// module chunks = 0